export default {
  'list-type': (h, conf, key) => {
    const list = []
    const config = conf.bpmConfig
    if (conf['list-type'] === 'picture-card') {
      list.push(<i class='el-icon-plus'></i>)
    } else {
      list.push(<el-button size='small' type='primary' icon='el-icon-upload'>上传附件</el-button>)
    }
    if (config.showTip) {
      list.push(
        <div slot='tip' class='el-upload__tip'>只能上传不超过 {config.fileSize}{config.sizeUnit} {conf.accept} 的文件</div>
      )
    }
    return list
  }
}
